import Axios from 'axios';
import { API_URL } from '../constants/Global';

const restClient = Axios.create({
  baseURL: API_URL,
});

restClient.interceptors.request.use(async (request) => ({
  ...request,
  headers: {
    ...request.headers,
    'X-Fleetback-Origin': 'FO',
    'X-Fleetback-Path': window.location.pathname + window.location.search,
  },
}));

export default restClient;
